/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import useSocialMediaData from '../../hooks/useSocialMediaData';
import FormContact from '../FormContact'
import ContactConfirmationModal from './ContactConfirmationModal';

const ContactModal = (props) => {

    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    const {social_media} = useSocialMediaData();


    // referencias a los elementos que me interesa monitorear
    const containerRef = useRef(null);
    const closeRef = useRef(null);

    // cerrar si el click fue afuera del contenedor o en la x
    const handleClose = (e) => {
        if (props.onClose && (!containerRef.current.contains(e.target) || closeRef.current.contains(e.target))) {
            props.onClose(false);
        }
    };

    const contactFormSended = () => {
        setShowConfirmationModal(true);
    }

    // habilitar y deshabilitar scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = null;
        }
    }, [])

    return (
        <section className='contact-modal'>
            <div
                className={"modal " + (!showConfirmationModal ? "show" : "")}
                onClick={handleClose}>
                <div ref={containerRef} className='modal-box large'>
                    <div className='modal-header'>
                        <h3 className='title3'>Contacto comercial</h3>
                        <span
                            className='modal-close'
                            ref={closeRef}
                            onClick={handleClose}>
                            ✕
                        </span>
                    </div>
                    <div className='modal-content'>
                        <div className='modal-body'>
                            <div className='grid-2 contact-container'>
                                <div className='info-section'>
                                    <h4 className='title4'>
                                        ¿En qué podemos ayudarte?{" "}
                                    </h4>
                                    <p>Comunícate con nosotros al +56 22 490 8080,<br></br>
                                    horario de Contact Center 24/7.</p>
                                    <div className='social-media'>
                                        <div className='subtitle'>
                                            Sigue a Kinto en sus redes
                                        </div>
                                        <ul className='social-media-list'>
                                            {social_media?.facebook ? (
                                                <li>
                                                    <a
                                                        href={
                                                            social_media.facebook
                                                        }>
                                                        <svg
                                                            xmlns='http://www.w3.org/2000/svg'
                                                            width='35'
                                                            height='35'
                                                            viewBox='0 0 35 35'>
                                                            <g
                                                                fill='none'
                                                                fillRule='evenodd'>
                                                                <rect
                                                                    className='inner'
                                                                    width='35'
                                                                    height='35'
                                                                    rx='17.5'></rect>
                                                                <path
                                                                    className='outer'
                                                                    d='M20.514 9.625c-.003.05-.008.1-.008.15 0 .805-.003 1.61.002 2.415 0 .113-.033.14-.142.14-.44-.005-.881-.004-1.322.004-.15.003-.3.026-.449.053-.277.053-.48.277-.492.588-.021.567-.018 1.134-.029 1.702-.001.103.068.085.128.085h2.316l-.286 2.7h-2.154v.17l-.003 7.536c0 .045-.003.091-.004.137h-2.947l.002-.138V17.466h-1.963c-.004-.055-.008-.095-.008-.136 0-.81.002-1.62-.003-2.43 0-.111.034-.14.143-.139.562.005 1.125-.001 1.687.005.12.001.146-.039.147-.15.003-.726 0-1.453.025-2.178.02-.528.13-1.042.377-1.52.27-.523.69-.88 1.249-1.056.309-.098.636-.14.956-.207l.133-.03h2.645z'></path>
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </li>
                                            ) : (
                                                ""
                                            )}

                                            {social_media?.youtube ? (
                                                <li>
                                                    <a
                                                        href={
                                                            social_media.youtube
                                                        }>
                                                        <svg
                                                            xmlns='http://www.w3.org/2000/svg'
                                                            width='35'
                                                            height='35'
                                                            viewBox='0 0 35 35'>
                                                            <g
                                                                fill='none'
                                                                fillRule='evenodd'>
                                                                <rect
                                                                    className='inner'
                                                                    width='35'
                                                                    height='35'
                                                                    fill='#FFF'
                                                                    fillRule='nonzero'
                                                                    rx='17.5'></rect>
                                                                <path
                                                                    className='outer'
                                                                    fill='#00708D'
                                                                    d='M18.048 10.001c1.085.007 4.16.039 6.348.209.377.051 1.2.056 1.932.895.577.643.767 2.102.767 2.102s.195 1.71.195 3.422v1.603c0 1.716-.195 3.426-.195 3.426s-.186 1.455-.767 2.098c-.731.844-1.555.849-1.932.895-2.7.214-6.75.224-6.75.224s-5.014-.051-6.56-.215c-.427-.088-1.393-.06-2.128-.904-.577-.638-.763-2.098-.763-2.098S8 19.948 8 18.232v-1.809c.014-1.503.166-2.953.192-3.184l.003-.032s.186-1.459.763-2.102c.735-.84 1.555-.844 1.932-.895 2.189-.17 5.266-.202 6.352-.209zm-2.397 4.236v1.385l.004 4.559 5.208-2.96L18 15.58l-2.35-1.343z'></path>
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </li>
                                            ) : (
                                                ""
                                            )}

                                            {social_media?.instagram ? (
                                                <li>
                                                    <a href={social_media?.instagram}>
                                                        <svg
                                                            xmlns='http://www.w3.org/2000/svg'
                                                            width='35'
                                                            height='35'
                                                            viewBox='0 0 35 35'>
                                                            <g
                                                                fill='none'
                                                                fillRule='evenodd'>
                                                                <rect
                                                                    className='inner'
                                                                    width='35'
                                                                    height='35'
                                                                    fillRule='nonzero'
                                                                    rx='17.5'></rect>
                                                                <path
                                                                    className='outer'
                                                                    d='M20.783 9.115c2.658 0 4.834 2.09 4.834 4.644v7.112c0 2.554-2.176 4.644-4.834 4.644h-6.949C11.175 25.515 9 23.425 9 20.87V13.76c0-2.554 2.175-4.644 4.834-4.644h6.949zm0 1.227h-6.949c-.945 0-1.836.357-2.51 1.005-.675.648-1.047 1.504-1.047 2.412v7.112c0 .908.372 1.764 1.046 2.412.675.648 1.566 1.005 2.511 1.005h6.949c.944 0 1.836-.357 2.51-1.005.675-.648 1.046-1.504 1.046-2.412V13.76c0-.908-.371-1.764-1.046-2.412-.674-.648-1.566-1.005-2.51-1.005zm-3.449 2.514c2.527 0 4.576 1.968 4.576 4.396 0 2.427-2.049 4.395-4.576 4.395-2.527 0-4.576-1.968-4.576-4.395 0-2.428 2.049-4.396 4.576-4.396zm-.022 1.521c-1.655 0-2.996 1.289-2.996 2.878 0 1.59 1.341 2.878 2.996 2.878s2.996-1.288 2.996-2.878-1.341-2.878-2.996-2.878zm4.671-2.63c.598 0 1.084.466 1.084 1.04 0 .576-.486 1.042-1.084 1.042-.598 0-1.083-.466-1.083-1.041s.485-1.04 1.083-1.04z'></path>
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </li>
                                            ) : (
                                                ""
                                            )}

                                            {social_media?.linkedin ? (
                                                <li>
                                                    <a href={social_media?.linkedin}>
                                                        <svg
                                                            xmlns='http://www.w3.org/2000/svg'
                                                            width='35'
                                                            height='35'
                                                            viewBox='0 0 35 35'>
                                                            <g
                                                                fill='none'
                                                                fillRule='evenodd'>
                                                                <rect
                                                                    className='inner'
                                                                    width='35'
                                                                    height='35'
                                                                    fillRule='nonzero'
                                                                    rx='17.5'></rect>
                                                                <path
                                                                    className='outer'
                                                                    d='M13.242 13.223c.274 0 .498.223.498.496v8.72c0 .248-.224.471-.498.471h-1.991c-.274 0-.498-.223-.498-.497V13.72c0-.273.199-.496.473-.496h2.016zm8.488-.249c1.842 0 3.211 1.441 3.211 3.28h.025v6.408c0 .1-.15.248-.249.248h-2.489c-.1 0-.249-.149-.249-.248v-5.34c0-.473-.124-.895-.423-1.193-.324-.323-.747-.497-1.22-.497-.92.025-1.618.795-1.618 1.714v5.366c0 .099-.15.198-.249.198h-2.738c-.1 0-.249-.099-.249-.198v-9.266c0-.124.15-.223.25-.223h2.488c.1 0 .25.149.25.248v.994l.018-.02.23-.229c.523-.77 1.494-1.242 2.49-1.242zm-9.459-4.223c.946 0 1.743.795 1.743 1.739 0 .994-.847 1.764-1.743 1.739-.92.025-1.742-.745-1.742-1.739-.025-.969.772-1.739 1.742-1.739z'></path>
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </li>
                                            ) : (
                                                ""
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                <div className='contact-section'>
                                    <FormContact
                                        contactFormSended={contactFormSended}
                                    />
                                </div>
                                <div className='social-media social-media-footer'>
                                    <div className='subtitle'>
                                        Sigue a Kinto en sus redes
                                    </div>
                                    <ul className='social-media-list'>
                                        {social_media?.facebook ? (
                                            <li>
                                                <a
                                                    href={
                                                        social_media.facebook
                                                    }>
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='35'
                                                        height='35'
                                                        viewBox='0 0 35 35'>
                                                        <g
                                                            fill='none'
                                                            fillRule='evenodd'>
                                                            <rect
                                                                className='inner'
                                                                width='35'
                                                                height='35'
                                                                rx='17.5'></rect>
                                                            <path
                                                                className='outer'
                                                                d='M20.514 9.625c-.003.05-.008.1-.008.15 0 .805-.003 1.61.002 2.415 0 .113-.033.14-.142.14-.44-.005-.881-.004-1.322.004-.15.003-.3.026-.449.053-.277.053-.48.277-.492.588-.021.567-.018 1.134-.029 1.702-.001.103.068.085.128.085h2.316l-.286 2.7h-2.154v.17l-.003 7.536c0 .045-.003.091-.004.137h-2.947l.002-.138V17.466h-1.963c-.004-.055-.008-.095-.008-.136 0-.81.002-1.62-.003-2.43 0-.111.034-.14.143-.139.562.005 1.125-.001 1.687.005.12.001.146-.039.147-.15.003-.726 0-1.453.025-2.178.02-.528.13-1.042.377-1.52.27-.523.69-.88 1.249-1.056.309-.098.636-.14.956-.207l.133-.03h2.645z'></path>
                                                        </g>
                                                    </svg>
                                                </a>
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {social_media?.youtube ? (
                                            <li>
                                                <a
                                                    href={
                                                        social_media.youtube
                                                    }>
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='35'
                                                        height='35'
                                                        viewBox='0 0 35 35'>
                                                        <g
                                                            fill='none'
                                                            fillRule='evenodd'>
                                                            <rect
                                                                className='inner'
                                                                width='35'
                                                                height='35'
                                                                fill='#FFF'
                                                                fillRule='nonzero'
                                                                rx='17.5'></rect>
                                                            <path
                                                                className='outer'
                                                                fill='#00708D'
                                                                d='M18.048 10.001c1.085.007 4.16.039 6.348.209.377.051 1.2.056 1.932.895.577.643.767 2.102.767 2.102s.195 1.71.195 3.422v1.603c0 1.716-.195 3.426-.195 3.426s-.186 1.455-.767 2.098c-.731.844-1.555.849-1.932.895-2.7.214-6.75.224-6.75.224s-5.014-.051-6.56-.215c-.427-.088-1.393-.06-2.128-.904-.577-.638-.763-2.098-.763-2.098S8 19.948 8 18.232v-1.809c.014-1.503.166-2.953.192-3.184l.003-.032s.186-1.459.763-2.102c.735-.84 1.555-.844 1.932-.895 2.189-.17 5.266-.202 6.352-.209zm-2.397 4.236v1.385l.004 4.559 5.208-2.96L18 15.58l-2.35-1.343z'></path>
                                                        </g>
                                                    </svg>
                                                </a>
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {social_media?.instagram ? (
                                            <li>
                                                <a href={social_media?.instagram}>
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='35'
                                                        height='35'
                                                        viewBox='0 0 35 35'>
                                                        <g
                                                            fill='none'
                                                            fillRule='evenodd'>
                                                            <rect
                                                                className='inner'
                                                                width='35'
                                                                height='35'
                                                                fillRule='nonzero'
                                                                rx='17.5'></rect>
                                                            <path
                                                                className='outer'
                                                                d='M20.783 9.115c2.658 0 4.834 2.09 4.834 4.644v7.112c0 2.554-2.176 4.644-4.834 4.644h-6.949C11.175 25.515 9 23.425 9 20.87V13.76c0-2.554 2.175-4.644 4.834-4.644h6.949zm0 1.227h-6.949c-.945 0-1.836.357-2.51 1.005-.675.648-1.047 1.504-1.047 2.412v7.112c0 .908.372 1.764 1.046 2.412.675.648 1.566 1.005 2.511 1.005h6.949c.944 0 1.836-.357 2.51-1.005.675-.648 1.046-1.504 1.046-2.412V13.76c0-.908-.371-1.764-1.046-2.412-.674-.648-1.566-1.005-2.51-1.005zm-3.449 2.514c2.527 0 4.576 1.968 4.576 4.396 0 2.427-2.049 4.395-4.576 4.395-2.527 0-4.576-1.968-4.576-4.395 0-2.428 2.049-4.396 4.576-4.396zm-.022 1.521c-1.655 0-2.996 1.289-2.996 2.878 0 1.59 1.341 2.878 2.996 2.878s2.996-1.288 2.996-2.878-1.341-2.878-2.996-2.878zm4.671-2.63c.598 0 1.084.466 1.084 1.04 0 .576-.486 1.042-1.084 1.042-.598 0-1.083-.466-1.083-1.041s.485-1.04 1.083-1.04z'></path>
                                                        </g>
                                                    </svg>
                                                </a>
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {social_media?.linkedin ? (
                                            <li>
                                                <a href={social_media?.linkedin}>
                                                    <svg
                                                        xmlns='http://www.w3.org/2000/svg'
                                                        width='35'
                                                        height='35'
                                                        viewBox='0 0 35 35'>
                                                        <g
                                                            fill='none'
                                                            fillRule='evenodd'>
                                                            <rect
                                                                className='inner'
                                                                width='35'
                                                                height='35'
                                                                fillRule='nonzero'
                                                                rx='17.5'></rect>
                                                            <path
                                                                className='outer'
                                                                d='M13.242 13.223c.274 0 .498.223.498.496v8.72c0 .248-.224.471-.498.471h-1.991c-.274 0-.498-.223-.498-.497V13.72c0-.273.199-.496.473-.496h2.016zm8.488-.249c1.842 0 3.211 1.441 3.211 3.28h.025v6.408c0 .1-.15.248-.249.248h-2.489c-.1 0-.249-.149-.249-.248v-5.34c0-.473-.124-.895-.423-1.193-.324-.323-.747-.497-1.22-.497-.92.025-1.618.795-1.618 1.714v5.366c0 .099-.15.198-.249.198h-2.738c-.1 0-.249-.099-.249-.198v-9.266c0-.124.15-.223.25-.223h2.488c.1 0 .25.149.25.248v.994l.018-.02.23-.229c.523-.77 1.494-1.242 2.49-1.242zm-9.459-4.223c.946 0 1.743.795 1.743 1.739 0 .994-.847 1.764-1.743 1.739-.92.025-1.742-.745-1.742-1.739-.025-.969.772-1.739 1.742-1.739z'></path>
                                                        </g>
                                                    </svg>
                                                </a>
                                            </li>
                                        ) : (
                                            ""
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showConfirmationModal ? (
                <ContactConfirmationModal onClose={handleClose} />
            ) : null}
        </section>
    );

}

export default ContactModal;